export function updatePointsInHeader() {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=get_current_points",
        datatype: "json",
        data: {
            // #237135: the server takes the customer from the session of this site
            "ajax_call_site_code": (typeof siteCode !== "undefined" && siteCode) ? siteCode : (window.location.pathname.split("/")[1] || "")
        },
        success: function (output) {
            $('#points_banner_header_inner_id').text(output);
        }
    });
}